import type { AccountConfig } from '#types/config/pages/account'
import type { RecursivePartial } from '#types/utils'

export default {
  orderHistory: {
    image: {
      height: { lg: 344, md: 109 },
      width: { lg: 344, md: 109 }
    }
  }
} satisfies RecursivePartial<AccountConfig>
